import React from 'react';
import propTypes from 'prop-types';
import MapComponent from '../Map';
import Confirm from '../Confirm';
import * as navigator from '../../native/navigator';
import './index.css';
import Detector from '../../utils/detector';
const isZuzuche = Detector.browser.zuzuche;
const isTantuMap = Detector.browser.tantumap;


export default class LittleAskCard extends React.Component {
  render(){
    let {poi, maxZoom} = this.props;
    let {lat, lng} = poi.info;
    let marker = lat && lng ? {
      type: 'locateMarker',
      className: 'locate',
      size: {
        width: '0.6rem',
        height: '0.6rem'
      },
      latLng:[lat, lng],
      imageUrl: '//imgcdn5.zuzuche.com/m_tantu_image/20180130/8095666e20b3206ab9c08f4b6af334a6.png'
    } : {};
  
    return (
      <div className='map-wrap'>
        <MapComponent markers={[marker]} maxZoom={maxZoom || 18} />
        <div className='card-mask'>
          <div className="card" onClick={this.showCard}>问路卡</div>
          <div className="locate" onClick={this.handleNavigation}>导航</div>
        </div>
        <div className='map-mask' onClick={this.goToPoiMapPage}></div>
      </div>
    );
  }

  /**
   * 点击导航 去 大地图页面
   */
  goToPoiMapPage = ()=>{
    let { poi } = this.props;
    navigator.push('/m/v2/?m=render2&page=poi-map', {
      poi_uid: poi.poi_uid
    });
  }

  /**
   * 显示问路卡
   */
  showCard = ()=>{
    this.props.handleClickAskCard();
  }
 
  /**
   * 点击导航 
   * 租租车&旅行：弹出确认框
   * 探途地图：直接导航
   */ 
  handleNavigation = ()=>{
    let {poi} = this.props;
    if (isTantuMap) {
      navigator.tanTuMap(poi);
    } else {
      Confirm({
        content: `即将离开"${isZuzuche ? '租租车' : '探途旅行'}"，打开"探途离线地图"`,
        confirmText: '允许',
        cancelText: '取消',
        confirmCallback: function () {
          console.log('跳转到探途地图导航');
          navigator.tanTuMap(poi);
        }
      });
    }
  }
}



Map.propTypes = {
  poi: propTypes.object.isRequired
};



LittleAskCard.propTypes = {
  poi: propTypes.object.isRequired,
  handleClickAskCard: propTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/LittleAskCard/index.js